import { jwtDecode } from 'jwt-decode'

import { IMPERSONATION_AMR } from './constants'
import { JwtWithAmr } from './types'

const decodeJwt = (token: string | null): JwtWithAmr | null => {
  if (!token) {
    return null
  }

  try {
    return jwtDecode<JwtWithAmr>(token)
  } catch {
    return null
  }
}

export const hasImpersonationAmr = (token: string | null): boolean => {
  const decoded = decodeJwt(token)

  return decoded?.amr?.includes(IMPERSONATION_AMR) ?? false
}
